import { Localization } from "@viamap/viamap2-common";
import { ReactNode } from "react";
import { MIBIcon } from "src/componentsUtils/MIBIcon";
import { MitPatt } from "src/components/GenerateGeomComponents";
import { JPB_BUFFER_POINT_PIN_COLOR } from "./jpbBufferPinLegend";
import { JPB_MARK_SHARE_SYMBOLS } from "./JPBMapLayers";

export function JPBLegendList() {
  return (
    <div className="Group" key="JPBLegend">
      <div className="Line">
        <div className="TitleIcon">
          <MIBIcon icon="JPB" />
        </div>
        <div className="Title">
          <b>{Localization.getText("JPB symbols")}</b>
        </div>
      </div>

      <div className="Group">
        <JPBLegendSearchAreaOutlineRow
          label={Localization.getText("jpb:legendSearchAreaOutline")}
        />
        <JPBLegendRow
          label={Localization.getText("jpb:legendIncludedCleanLand")}
          circleColor="#3a8e87"
        />
        <JPBLegendRow
          label={Localization.getText("jpb:legendIncludedWithBuildings")}
          circleColor="#3a8e87"
          overlay={<MIBIcon icon="house" />}
        />
        <JPBLegendRow
          label={Localization.getText("jpb:legendExcludedCleanLandRemovedByRule")}
          circleColor="#606060"
        />
        <JPBLegendRow
          label={Localization.getText("jpb:legendExcludedWithBuildingsRemovedByRule")}
          circleColor="#606060"
          overlay={<MIBIcon icon="house" />}
        />
        <JPBLegendRow
          label={Localization.getText("jpb:legendExcludedInsufficientDeedInfoRemovedByRule")}
          circleColor="#1f1f1f"
        />
        <JPBLegendRow
          label={Localization.getText("jpb:legendExcludedWithBuildingsInsufficientLand")}
          circleColor="#1f1f1f"
          overlay={<MIBIcon icon="house" />}
        />
        <JPBLegendRow
          label={Localization.getText("jpb:legendExcludedInsufficientDeedInfo")}
          circleColor="#1f1f1f"
          overlay="!"
        />
        <JPBLegendGlyphRow
          label={Localization.getText("jpb:markOmdrift")}
          glyph={JPB_MARK_SHARE_SYMBOLS.omdrift.glyph}
        />
        <JPBLegendGlyphRow
          label={Localization.getText("jpb:markIkkeOmdrift")}
          glyph={JPB_MARK_SHARE_SYMBOLS.ikkeOmdrift.glyph}
          pattern={JPB_MARK_SHARE_SYMBOLS.ikkeOmdrift.iconPattern}
        />
        <JPBLegendGlyphRow
          label={Localization.getText("jpb:markSection3")}
          glyph={JPB_MARK_SHARE_SYMBOLS.section3.glyph}
          color={JPB_MARK_SHARE_SYMBOLS.section3.line}
        />
      </div>
    </div>
  );
}

/** 90° arc, corner-centered to fill the 20×20 swatch; stroke matches JPB search-area outline. */
function JPBLegendSearchAreaOutlineRow(props: { label: string }) {
  return (
    <div className="Line">
      <div className="Color">
        <div
          style={{
            width: 20,
            height: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          aria-hidden
        >
          <svg width="20" height="20" viewBox="0 0 20 20" style={{ display: "block" }}>
            <path
              d="M 18 18 A 16 16 0 0 1 2 2"
              fill="none"
              stroke={JPB_BUFFER_POINT_PIN_COLOR}
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
      <div className="Operator"></div>
      <div className="Text" style={{ textAlign: "left" }}>
        {props.label}
      </div>
      <div className="Count"></div>
    </div>
  );
}

function JPBLegendGlyphRow(props: { label: string; glyph: string; color?: string; pattern?: string }) {
  return (
    <div className="Line">
      <div className="Color">
        {props.pattern ? (
          <MitPatt pattern={props.pattern} />
        ) : (
          <div
            style={{
              width: 20,
              height: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: props.glyph.length > 1 ? 13 : 16,
              fontWeight: 700,
              lineHeight: 1,
              color: props.color,
            }}
            aria-hidden
          >
            {props.glyph}
          </div>
        )}
      </div>
      <div className="Operator"></div>
      <div className="Text" style={{ textAlign: "left" }}>
        {props.label}
      </div>
      <div className="Count"></div>
    </div>
  );
}

function JPBLegendRow(props: { label: string; circleColor: string; overlay?: ReactNode }) {
  return (
    <div className="Line">
      <div className="Color">
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: props.circleColor,
            border: "2px solid #ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1
          }}
        >
          {props.overlay}
        </div>
      </div>
      <div className="Operator"></div>
      <div className="Text" style={{ textAlign: "left" }}>
        {props.label}
      </div>
      <div className="Count"></div>
    </div>
  );
}
